export default "__VITE_ASSET__a68b43ba__"